import { jsxs, jsx } from 'react/jsx-runtime';

const SvgFileAddFill = (props) => jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: [jsx("path", { fill: "#2D2E2E", d: "M14 8V2H4v20h16V8h-6Zm2 7h-3v3h-2v-3H8v-2h3v-3h2v3h3v2Z" }), jsx("path", { fill: "#2D2E2E", d: "M15.5 2.09V6.5h4.41L15.5 2.09Z" })] }));

export { SvgFileAddFill as default };
//# sourceMappingURL=FileAddFill.es.js.map
